module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Router.874478aa.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Router.svg
// module id = 1613
// module chunks = 0